import React from "react";
import { I18n } from "@aws-amplify/core";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core";
import update from "immutability-helper";
import { get, isEmpty, map, includes, filter } from "lodash";

import Box from "@material-ui/core/Box";

import CustomButton from "../../Common/CustomButton";
import FormSection from "../../Common/FormSection";

import { getLov } from "../../../utils/lov";

const styles = {
  gridLine: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, 200px)",
    gridAutoRows: "56px",
    gridGap: "24px",
  },
};

const CompanyCountsForm = (props) => {
  const { classes, user, search, language } = props;
  const [filters, setFilters] = React.useState({});
  const [profileTypes, setProfileTypes] = React.useState();

  React.useEffect(() => {
    fetchLov();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Set initial filters
  React.useEffect(() => {
    if (!isEmpty(profileTypes)) {
      setFilters(
        update(filters, {
          profileTypes: { $set: map(profileTypes, (t) => t.id) },
          assigned_company: { 
            $set: get(user, ["companies", 0, "id"]) 
          },
          assigned_sites: {
            $set: map(get(user, ["companies", 0, "sites"]), (s) => s.id),
          },
          company: { 
            // $set: get(user, ["companies", 0, "id"]) 
            // use All Companies by default
            $set: -1 
          },
          sites: {
            // $set: map(get(user, ["companies", 0, "sites"]), (s) => s.id),
            // use All Sites by default
            $set: [-1]
          },
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileTypes]);

  const fetchLov = async () => {
    try {
      const profileTypes = await getLov("profileTypes");
      setProfileTypes(
        filter(profileTypes, (t) => t.active && includes([1, 2, 3, 4], t.id))
      );
    } catch (e) {
      console.log(e);
    }
  };

  const handleChange = (id, index, value) => {
    if (id === "company") {
      setFilters(
        update(filters, {
          [id]: { $set: value },
          sites: {
            $set: (() => {
              let result = [-1];
              if (value !== -1) {
                result = map(
                  get(
                    filter(get(user, ["companies"]), (c) => c.id === value),
                    [0, "sites"]
                  ),
                  (s) => s.id
                );
              }
              return result;
            })(),
          },
        })
      );
    } else if (id === "sites") {
      setFilters(
        update(filters, {
          [id]: { $set: value },
        })
      );
    }
    else if (id === "assigned_company") {
      setFilters(
        update(filters, {
          [id]: { $set: value },
          assigned_sites: {
            $set: map(
              get(
                filter(get(user, ["companies"]), (c) => c.id === value),
                [0, "sites"]
              ),
              (s) => s.id
            ),
          },
        })
      );
    } else if (id === "assigned_sites") {
      if (value.length < 1) {
        value =
          filters["assigned_sites"].length === 1
            ? filters["assigned_sites"]
            : [filters["assigned_sites"][0]];
      }
      setFilters(
        update(filters, {
          [id]: { $set: value },
        })
      );
    }
  };

  return (
    <>
      <Box className={classes.gridLine}>
        <Box>
          <FormSection
            formValue={[get(filters, ["assigned_company"])]}
            setFormValue={handleChange}
            title2={I18n.get("assigned_company")}
            id={"assigned_company"}
            type="select"
            options={{
              options: map(get(user, ["companies"]), item => ({
                id: get(item, ["id"]),
                name: get(item, ["name"])
              }))
            }}
          />
        </Box>
        <Box>
          <FormSection
            formValue={get(filters, ["assigned_sites"]) || []}
            setFormValue={handleChange}
            title2={I18n.get("assigned_site")}
            id={"assigned_sites"}
            type="select"
            options={{
              selectAll: true,
              multipleSelect: true,
              clickThrough: true,
              options: map(
                get(
                  filter(
                    get(user, ["companies"]),
                    c => c.id === get(filters, ["assigned_company"])
                  ),
                  [0, "sites"]
                ),
                item => ({
                  id: get(item, ["id"]),
                  name: get(item, ["name"])
                })
              )
            }}
          />
        </Box>
      </Box>
      <Box className={classes.gridLine} style={{display: 'none'}}>
        <Box>
          <FormSection
            formValue={[get(filters, ["company"])]}
            setFormValue={handleChange}
            title2={I18n.get("show_company")}
            id={"company"}
            type="select"
            options={{
              options: map(
                [
                  ...get(user, ["companies"]),
                  { id: -1, name: I18n.get("all_companies") }
                ],
                item => ({
                  id: get(item, ["id"]),
                  name: get(item, ["name"])
                })
              )
            }}
          />
        </Box>
        <Box>
          <FormSection
            formValue={get(filters, ["sites"]) || []}
            setFormValue={handleChange}
            title2={I18n.get("show_site")}
            id={"sites"}
            type="select"
            options={{
              selectAll: get(filters, ["company"]) !== -1,
              multipleSelect: get(filters, ["company"]) !== -1,
              clickThrough: get(filters, ["company"]) !== -1,
              options: (() => {
                let result = [{ id: -1, name: I18n.get("all_sites") }];
                if (get(filters, ["company"]) !== -1) {
                  result = map(
                    get(
                      filter(
                        get(user, ["companies"]),
                        c => c.id === get(filters, ["company"])
                      ),
                      [0, "sites"]
                    ),
                    item => ({
                      id: get(item, ["id"]),
                      name: get(item, ["name"])
                    })
                  );
                }
                return result;
              })()
            }}
          />
        </Box>
      </Box>
      <Box className={classes.gridLine}>
        <Box style={{ display: "flex", alignItems: "flex-end" }}>
          <CustomButton
            variant="contained"
            color="primary"
            onClick={() => search(filters)}
          >
            {I18n.get("dashboard_search")}
          </CustomButton>
        </Box>
      </Box>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(CompanyCountsForm));
